'use client'
import { useState } from "react";
import { ChevronDown, ChevronUp } from "@/assets/icons";
import { useRouter } from "next/navigation";
import { logout } from "@/app/api";
import { Button, SmartLink } from "@/components/ui";

export function SellerMenu() {
    const router = useRouter();
    const handleClick = async () => {
        try {
            const response = await logout();
            if (response.success) {
                router.push(`${process.env.NEXT_PUBLIC_PRIMARY_DOMAIN}`)
                router.refresh();
                setMenuSellerOpen(false)
            }
        } catch (e) {
            console.log('Erro ao fazer logout:', e);
        }
    };
    const [menuSellerOpen, setMenuSellerOpen] = useState<boolean>(false);
    return (
        <div>
            <Button onClick={() => setMenuSellerOpen(menuSellerOpen ? false : true)}
                className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                <ChevronDown className={`size-6 ${menuSellerOpen ? 'hidden' : 'flex'}`} />
                <ChevronUp className={`size-6 ${menuSellerOpen ? 'flex' : 'hidden'}`} />
            </Button>

            <div className={`${menuSellerOpen ? 'flex' : 'hidden'}`}>
                <div className="absolute flex flex-col mt-6 -ms-32 z-50 p-8 gap-6 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500">

                    <SmartLink type={"internal"} route={"seller"} onClick={() => setMenuSellerOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Dashboard
                    </SmartLink>

                    <button className="cursor-pointer flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent" onClick={handleClick}>
                        <span>Sair</span>
                    </button>
                </div>
                <div onClick={() => setMenuSellerOpen(false)} className="absolute w-screen h-screen top-0 left-0 z-30 cursor-pointer" />
            </div>
        </div>
    )
}